<script>
  import { Vue, mapGetters, storeFuns, apiFuns } from "sw-hic";
  import api from "./api";
  export default {
    props: {
      id: Number,
      value: Object,
      paras: Object,
    },
    components: {
      Module: () => import("./module.vue"),
    },
    data() {
      return {
        module: null,
        errMsg: null,
        js: {},
      };
    },
    computed: {
      ...mapGetters(["user", "userRoles", "dict"]),
    },
    mounted() {
      if (this.value) {
        this.module = this.value;
      } else if (this.id) {
        this.module = this.dict.WebModule.find((m) => m.id == this.id);
      }
      if (this.module && this.module.js) {
        this.js = eval("(" + this.module.js + ")");
      }
      if (this.js.init) {
        this.storeFuns = storeFuns;
        this.apiFuns = apiFuns;
        this.js.init(this);
      }
      if (this.module.extraSql) {
        this.js.sqls = JSON.parse(this.module.extraSql);
        this.js.sqls.forEach((sql) => {
          if (sql.type == "字典" && !this.dict[sql.code] && (!this.js.dict || !this.js.dict[sql.code])) {
            api.Module.execSql({
              dbSqls: [{ code: sql.db, sql: sql.sql }],
              resultType: "列表",
              indexStart: 1,
              param: {
                pageSize: 9999,
                pageIndex: 1,
                ...this.paras,
              },
            }).then((res) => {
              this.$store.commit("dict", { type: sql.code, items: res.items });
            });
          }
        });
      }
    },
    methods: {
      translate(code, type) {
        if (this.dict[type]) {
          return this.$utils.Dict.text(code, type);
        }
        if (this.js.dict && this.js.dict[type]) {
          let d = this.js.dict[type].find((d) => d.code == code);
          if (d) {
            return d.text;
          }
        }
        return code;
      },
      errView() {
        return Vue.extend({
          template: `<el-row><span>${this.errMsg}</span></el-row>`,
        });
      },
      nomalView() {
        let _this = this;
        let content = _this.module.content;
        if (this.user.forSys) {
          content = content.replace("dynamic", "viewer");
        }
        return Vue.extend({
          template: `<el-row>${content}</el-row>`,
          components: {
            EmrEditor: () => import("./_emrEditor"),
          },
          filters: {
            trans(code, type) {
              return _this.translate(code, type);
            },
          },
          data() {
            return {
              data: {},
              con: {
                pageSize: 10,
                pageIndexOnView: 1,
              },
              paras: _this.paras, // 父组件带过来的参数
              vars: {}, // 变量容器（允许配置时添加临时变量）
            };
          },
          mounted() {
            if (_this.js.pageInit) {
              _this.js.pageInit(this);
            }
            this.page();
          },
          methods: {
            page() {
              if (_this.module.dbSql == "ignore") {
                return;
              }
              // if (this.loading) {
              //   return
              // }
              // this.loading
              if (_this.js.pageBefore) {
                _this.js.pageBefore(_this.paras, this, _this);
              }
              let dbsql = JSON.parse(_this.module.dbSql);
              let para = {
                dbSqls: dbsql,
                resultType: _this.module.resultType,
                indexStart: 1,
                param: {
                  pageSize: this.con.pageSize,
                  pageIndex: this.con.pageIndexOnView,
                  ..._this.paras,
                },
              };
              api.Module.execSql(para).then((res) => {
                if (_this.js.pageAfter) {
                  _this.js.pageAfter(res, this, _this);
                }
                if ("对象" == _this.module.resultType) {
                  this.data = res.items[0];
                } else {
                  this.data = res;
                }
              });
            },
            str(val) {
              return JSON.stringify(val);
            },
          },
        });
      },
    },
    render(h) {
      if (!this.module) {
        return;
      }

      this.errMsg = null;

      if (this.module.roles) {
        let roles = JSON.parse(this.module.roles);
        if (roles && roles.length && roles.findIndex((r) => this.userRoles.findIndex((ur) => (ur.roleCode = r.code)) >= 0) < 0) {
          this.errMsg = "您没有此模块的访问权限！";
        }
      }

      let com = this.errMsg ? this.errView() : this.nomalView();
      return h(com, {});
    },
  };
</script>
